module.exports = __webpack_public_path__ + "img/c-line-short.deb7da73.svg";